module.exports = __webpack_public_path__ + "img/success-icon.ddcd0752.png";